<template>
  <span
    class="inline-flex items-center font-bold px-2.5 py-0.5 rounded-full text-xs"
    :class="{
      'bg-indigo-100 text-indigo-800': status == 'Pending',
      'bg-green-100 text-green-800': status == 'Paid',
      'bg-orange-100 text-orange-800': status == 'Overdue',
      'bg-red-100 text-red-800': status == 'Canceled',
    }"
  >
    {{ $t(status) }}
  </span>
</template>

<script>
export default {
  props: { status: String },
};
</script>
